import { useDocumentGroupContext } from '@/creditflowresearch/application/Research/DocumentGroupContext';
import { useResearchFilterContext } from '@/creditflowresearch/application/Research/ResearchFilterContext';
import { useResearchDataFetching } from '@/creditflowresearch/application/Research/hooks/useResearchDataFetching';
import { useResearchPagination } from '@/creditflowresearch/application/Research/hooks/useResearchPagination';
import { useResearchDocumentGroup } from '@/creditflowresearch/application/Research/hooks/useResearchDocumentGroup';
import { useResearchPayloadBuilder } from '@/creditflowresearch/application/Research/hooks/useResearchPayloadBuilder';

export const useResearchTable = (
    state,
    setResearchData,
    requestPayload,
    searchFieldValue,
    isFirstFetch,
) => {
  const { resetResearchFilter } = useResearchFilterContext();
  const { setEmptyDocumentGroupIds } = useDocumentGroupContext();

  const {
    getDocumentById,
    getResearchList: fetchResearchList,
    getResearchForAllGroups: fetchResearchForAllGroups,
    isFetchingDocument,
    isFetchingResearchList,
    isFetchingAllGroups,
  } = useResearchDataFetching();

  const { prepareResearchPayload } = useResearchPayloadBuilder(
    state,
    requestPayload,
    searchFieldValue,
  );

  const getResearchList = async (payloadData) => {
    const payload = prepareResearchPayload(payloadData);
    await fetchResearchList(payload, setResearchData, isFirstFetch);
  };

  const { sort, paginate, itemsPerPage } = useResearchPagination(
    setResearchData,
    getResearchList,
  );

  const { documentGroupChanged, isChangingDocumentGroup } = useResearchDocumentGroup(
    searchFieldValue,
    paginate,
  );

  const getResearchForAllGroups = async (payloadData) => {
    const payload = prepareResearchPayload(payloadData);
    await fetchResearchForAllGroups(payload, setResearchData, setEmptyDocumentGroupIds, isFirstFetch);
  };

  const resetResearch = () => {
    resetResearchFilter();
  };

  return {
    getDocumentById,
    getResearchList,
    getResearchForAllGroups,
    sort,
    paginate,
    itemsPerPage,
    documentGroupChanged,
    resetResearch,
    isFetchingDocument,
    isFetchingResearchList,
    isFetchingAllGroups,
    isChangingDocumentGroup,
  };
};

export default useResearchTable;
